<template>
  <div class="contacts-container">
    <div class="area">
      <div
        class="row"
        style="position:relative"
        v-animated-show="utils.handleScroll"
      >
        <Map
          class="col-6 col-md-12"
          :places="places"
          :is-catalog="true"
          id="catalog-nav"
          ref="map"
        />
        <div class="spacer col-1 md-hidden"></div>
        <div class="contacts-block info col-5 col-md-12">
          <h2 v-html="info.title" class="col-5 col-md-12"></h2>
          <div class="contacts-info col-2 col-md-12">
            <Description
              class="address mini"
              :title="info.place.title"
              :desc="info.place.address"
              v-if="info.place.title"
            />
            <p
              class="phone"
              v-if="info.place.phone && info.place.phone.length > 0"
            >
              <strong
                class="p-tel"
                v-for="(l, i) in info.place.phone"
                :key="i"
                itemprop="telephone"
              >
                <a
                  class="phone-link link"
                  :href="utils.getPhoneLink(l.number)"
                  >{{ l.number }}</a
                >
              </strong>
            </p>
          </div>
          <div class="recall-info col-5 col-md-12" v-html="info.desc"></div>
        </div>

        <div class="outlets info col-5 col-md-12">
          <h2 v-html="outlets.title" class="col-5 col-md-12"></h2>
          <div class="addresses">
            <a
              href="/"
              v-for="(l, i) in outlets.list"
              :key="i"
              @click.prevent="
                () => {
                  selectMarker(l);
                }
              "
              class="address-block col-2 col-md-12"
            >
              <Description
                class="address mini"
                :title="l.title"
                :desc="l.desc"
                v-if="l.title"
              />
              <p class="phone" v-if="l.phone && l.phone.length > 0">
                <strong
                  class="p-tel"
                  v-for="(l, i) in l.phone"
                  :key="i"
                  itemprop="telephone"
                >
                  <a
                    class="phone-link link"
                    :href="utils.getPhoneLink(l.number)"
                    >{{ l.number }}</a
                  >
                </strong>
              </p>
            </a>
          </div>
        </div>

        <div class="shops info col-5 col-md-12">
          <h2 v-html="shops.title" class="col-5 col-md-12"></h2>
          <div class="addresses">
            <a
              href="/"
              v-for="(l, i) in shops.list"
              :key="i"
              @click.prevent="
                () => {
                  selectMarker(l);
                }
              "
              class="address-block col-2 col-md-12"
            >
              <Description
                class="address mini"
                :title="l.title"
                :desc="l.desc"
                v-if="l.title"
              />
              <p class="phone" v-if="l.phone && l.phone.length > 0">
                <strong
                  class="p-tel"
                  v-for="(l, i) in l.phone"
                  :key="i"
                  itemprop="telephone"
                >
                  <a
                    class="phone-link link"
                    :href="utils.getPhoneLink(l.number)"
                    >{{ l.number }}</a
                  >
                </strong>
              </p>
            </a>
          </div>
        </div>
        <div class="float-art-right2"></div>
      </div>
    </div>
  </div>
</template>

<script>
import utils from "../utils";
import Map from "../containers/Map";

export default {
  name: "Contacts",
  props: {
    theme: {
      default: "default",
    },
    info: Object,
    outlets: Object,
    shops: Object,
  },
  data() {
    return {
      utils: utils,
      current: 0,
    };
  },
  computed: {
    places() {
      return { list: [...this.outlets.list, ...this.shops.list] };
    },
  },
  methods: {
    selectMarker(item) {
      this.$refs.map.openWindow(item);
      this.utils.scrollTo(this.$refs.map.$el);
    },
    nextFeedback(offset) {
      this.current = Math.min(this.current + offset, this.list.length - 1);
    },
  },
  mounted() {
    this.current = 0;
  },
  components: { Map },
};
</script>

<style lang="scss">
.contacts-container {
  background: $bg-main;
  .map-component {
    transform: translate3d(0, 0, 0);
    @media all and (max-width: $md) {
      grid-row: unset;
      position: unset;
      will-change: transform;
    }
    position: -webkit-sticky;
    position: sticky;
    top: 26px;
    grid-row: span 3;
  }
  h2 {
    font-weight: bold;
    @media all and (max-width: $md) {
      font-size: 24px;
    }
  }
  @extend %page-block;
  .info {
    @media all and (max-width: $md) {
      margin-left: 0;
      grid-column: 1 / span 12;
      grid-template-columns: repeat(12, minmax(0, 1fr));
    }
    margin-left: -26px;
    display: grid;
    grid-gap: 42px 0;
    align-items: flex-start;
    align-content: flex-start;
    margin-top: 52px;
    grid-template-columns: repeat(5, minmax(0, 1fr));
    grid-column: 8 / span 5;
    grid-column-gap: 26px;
    &.outlets {
      @media all and (max-width: $md) {
        margin-top: 26px;
      }
    }
    &.contacts-block {
      @media all and (max-width: $md) {
        grid-column: 1 / span 12;
        grid-row: 1;
        margin-bottom: 14px;
        padding-left: 20px;
        padding-right: 20px;
      }
      margin-top: -20px;
    }
    .addresses {
      @media all and (max-width: $md) {
        grid-template-columns: repeat(12, minmax(0, 1fr));
        grid-column: 1 / span 12;
      }
      margin-top: -30px;
      display: grid;
      grid-column: 1 / span 5;
      grid-column-gap: 26px;
      grid-template-columns: repeat(5, minmax(0, 1fr));
    }
    h3 {
      @media all and (max-width: $md) {
        margin-right: 0;
      }
      margin-right: -26px;
    }
  }

  .phone {
    display: grid;
    grid-gap: 3px;
    color: $text-main;
    margin: 0;
    margin-top: 26px;
    a {
      @extend %text-mini;
      border-color: transparent;
    }
  }
  .description.address {
    .title {
      color: $color-accent;
    }
    .description-content {
      grid-gap: 5px;
    }
  }
  .contacts-info {
    position: relative;
    &::before {
      @media all and (max-width: $md) {
        left: -45px;
      }
      content: "";
      position: absolute;
      z-index: -1;
      left: -26px;
      top: -26px;
      bottom: -26px;
      right: -45px;
      display: block;
      background: $color-accent-light;
    }
  }
  .recall-info {
    @media all and (max-width: $md) {
      grid-column: 1 / span 8;
      margin-left: 0;
    }
    @extend %text-mini;
    grid-column: 4 / span 2;
    margin-left: -56px;
  }
  .address-block {
    @media all and (max-width: $md) {
      padding-left: 20px;
      padding-right: 20px;
    }
    position: relative;
    padding-bottom: 26px;
    padding-top: 26px;
    border-bottom: 1px solid $color-accent-quart;

    &::before {
      @media all and (max-width: $md) {
        left: -14px;
        right: -14px;
      }
      content: "";
      position: absolute;
      z-index: -1;
      left: -26px;
      top: 0;
      bottom: 0;
      right: 0px;
      display: block;
      transition: background-color 0.5s;
    }
    &:hover {
      &::before {
        background: $color-accent-light;
      }
    }

    &:nth-child(odd) {
      @media all and (max-width: $md) {
        margin-right: 0;
        grid-column: 1 / span 12;
      }
      margin-right: -45px;
      grid-column: 1 / span 2;
      .description {
        @media all and (max-width: $md) {
          border-right: none;
        }
        border-right: 1px solid $color-accent-quart;
      }
      &:nth-last-child(2) {
        @media all and (max-width: $md) {
          border-bottom: 1px solid $color-accent-quart;
        }
        border-bottom: transparent;
      }
      &:nth-last-child(1) {
        border-bottom: transparent;
      }
    }
    &:nth-child(even) {
      @media all and (max-width: $md) {
        margin-left: 0;
        padding-left: 20px;
        padding-right: 20px;
        grid-column: 1 / span 12;
      }
      padding-left: 26px;
      margin-left: -80px;
      grid-column: 4 / span 2;
      &::before {
        @media all and (max-width: $md) {
          left: -14px;
          right: -14px;
        }
        left: 0px;
        right: -14px;
      }
      &:nth-last-child(1) {
        border-bottom: transparent;
      }
    }
    // &:nth-last-child(2),
    // &:nth-last-child(1) {
    //   border-bottom: transparent;
    // }
  }

  .float-art-right2 {
    pointer-events: none;
    @media all and (max-width: $md) {
      align-self: flex-start;
      grid-column: 1 / span 12;
      right: 00px;
      transform: translate(40%) scaleX(-1);
      top: -9px;
      width: 212px;
      height: 222px;
      background: url(../assets/photos/history/rozh1_1@2x.png) no-repeat right;
      background-size: contain;
    }
    position: absolute;
    top: -49px;
    background: url(../assets/photos/contacts/rozh@2x.png) no-repeat right
      center;
    transform: translate(00px, 50%);
    right: calc((1088px - 100vw) / 2 - 120px);
    width: calc((100vw - 1088px) / 3 + 290px);
    height: calc((100vw - 1088px) / 3 + 290px);
    max-width: 600px;
    max-height: 600px;
    background-size: contain;
    align-self: flex-end;
  }
}
</style>
